<script setup>

</script>

<template>
  <svg class="fill-blue-700" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31.1667 14.8183L27.71 10.88L28.1917 5.66667L23.0775 4.505L20.4 0L15.5833 2.06833L10.7667 0L8.08917 4.505L2.975 5.6525L3.45667 10.8658L0 14.8183L3.45667 18.7567L2.975 23.9842L8.08917 25.1458L10.7667 29.6508L15.5833 27.5683L20.4 29.6367L23.0775 25.1317L28.1917 23.97L27.71 18.7567L31.1667 14.8183Z" fill="white"/>
    <path d="M31.1667 14.8183L27.71 10.88L28.1917 5.66667L23.0775 4.505L20.4 0L15.5833 2.06833L10.7667 0L8.08917 4.505L2.975 5.6525L3.45667 10.8658L0 14.8183L3.45667 18.7567L2.975 23.9842L8.08917 25.1458L10.7667 29.6508L15.5833 27.5683L20.4 29.6367L23.0775 25.1317L28.1917 23.97L27.71 18.7567L31.1667 14.8183ZM12.75 21.9017L7.08333 16.235L9.08083 14.2375L12.75 17.8925L22.0858 8.55667L24.0833 10.5683L12.75 21.9017Z" fill="#3F7BFF"/>
  </svg>
</template>

<style scoped>

</style>
